import { Pipe, PipeTransform } from '@angular/core';
import { StringUtils } from '../../utils/string.utils';

@Pipe({
  name: 'searchGlobal'
})
export class SearchGlobalPipe implements PipeTransform {

  transform(records: Array<any>, searchText?: string): any {
    if (StringUtils.isEmpty(searchText)) return records;

    searchText = StringUtils.turkishToEnglish(searchText!.toUpperCase());

    return records.filter(rec => {
      return Object.keys(rec).some(x => StringUtils.turkishToEnglish(String(rec[x]).toUpperCase()).includes(searchText));
    })
  }
}
